<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { Text } from '@Shelly/shelly-design-system';
	import { format } from '../../../services/i18n';
	import ConditionPreview from '../components/GenericView/ConditionPreview.svelte';
	import SectionContainer from '../components/GenericView/SectionContainer.svelte';
	import { is_channel_only_condition } from '../helpers/scene_conditions_to_ui';

	export let whens = [];

	const andDisplayList = (andArr: unknown[]) => {
		if (!Array.isArray(andArr)) return [];
		const andList = andArr as { r?: string; rr?: string }[];
		return andList
			.map((condition, realIndex) => ({ condition, realIndex }))
			.filter(({ condition }) => !is_channel_only_condition(condition));
	};

	const dispatch = createEventDispatcher();
</script>

<!--
	List of all whens parsed from sdr format to ui data
-->

{#each whens as single_el, main_ind}
	{@const displayList = andDisplayList(single_el.and)}
	<SectionContainer>
		{#each displayList as item, displayIndex (item.realIndex)}
			<ConditionPreview
				element={item.condition}
				on:edit-when={() => {
					dispatch('edit-when', { main_ind, sub_ind: item.realIndex });
				}}
			/>
			{#if displayIndex < displayList.length - 1}
				<Text class="text-center mt-s mb-s">{$format('and')}</Text>
			{/if}
		{/each}
	</SectionContainer>

	{#if main_ind < whens.length - 1}
		<Text class="text-center mt-s mb-s" styleType="body-small">
			{$format('or')}
		</Text>
	{/if}
{/each}
